import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

export interface CountryOption {
  code: string;
  name: string;
}

// Register the English locale lazily rather than at module load: `client-core` is marked
// `"sideEffects": false`, so a top-level registration could legally be tree-shaken away. Registering
// on first use (idempotent) keeps that package hint honest while guaranteeing names are available.
let localeRegistered = false;
function ensureEnglishLocale(): void {
  if (localeRegistered) return;
  countries.registerLocale(enLocale);
  localeRegistered = true;
}

/**
 * Get all ISO 3166-1 alpha-2 country codes with their English names.
 * Returns a sorted array of { code, name } objects.
 */
export function getCountriesList(): CountryOption[] {
  ensureEnglishLocale();
  const countryNames = countries.getNames('en', { select: 'official' }) as Record<string, string>;
  const codes = Object.keys(countries.getAlpha2Codes() as Record<string, string>);

  return codes
    .map((code) => ({ code, name: countryNames[code] ?? code }))
    .toSorted((a, b) => a.name.localeCompare(b.name));
}
